import React from 'react';
import PropTypes from 'prop-types';
import { Link, I18n, Status } from 'components';
import classNames from 'classnames/bind';

import styles from '../styles.pcss';
const cx = classNames.bind(styles);

export const SuccessDisconnectStatus = ({ id }) => (
  <Status className={[cx('message'), 'success']}>
    <I18n path="internet.messages.servicesDisconnect" vars={{ id }} />
    {' '}
    <Link className="light" href="#messages">Уведомления</Link>
  </Status>
);

SuccessDisconnectStatus.propTypes = {
  id: PropTypes.number,
};
